import gql from 'graphql-tag';

export const schoolFragment = gql`{
  id
  name
  costOfAttendance
  medias{id source}
}`
